import Tenant from './tenant.vue'
export default Tenant
